import React, { useEffect } from 'react';
import {
  Leaf,
  Droplet,
  Sun,
  Wind,
  ArrowRight,
  TrendingUp,
  Map,
  Users
} from 'lucide-react';
import './aboutus.css';

const AboutUs = () => {

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-organic-page">

      {/* 1. Soft Hero */}
      <section className="organic-hero">
        <div className="hero-backdrop"></div>
        <div className="hero-center-content reveal fade-up">
          <span className="pill-badge">EST. 2016</span>
          <h1 className="hero-title">Nature's Wisdom,<br />Modern Science.</h1>
          <p className="hero-desc">
            We bridge the gap between ancient agricultural traditions and
            future-forward sustainable technology.
          </p>
        </div>
      </section>

      {/* 2. Floating Cards Grid */}
      <section className="cards-section">
        <div className="organic-container">
          <div className="grid-layout">

            <div className="feature-card glass-panel reveal fade-up">
              <div className="card-icon-circle"><Leaf size={24} /></div>
              <h3>Sustainable Growth</h3>
              <p>Regenerating soil health through bio-diverse farming practices.</p>
            </div>

            <div className="feature-card glass-panel reveal fade-up delay-1">
              <div className="card-icon-circle"><Droplet size={24} /></div>
              <h3>Pure Resources</h3>
              <p>Precision irrigation systems that conserve every drop of water.</p>
            </div>

            <div className="feature-card glass-panel reveal fade-up delay-2">
              <div className="card-icon-circle"><Sun size={24} /></div>
              <h3>Energy Efficient</h3>
              <p>Harnessing solar power for our processing units and field ops.</p>
            </div>

          </div>
        </div>
      </section>

      {/* 3. Narrative Split */}
      <section className="narrative-split">
        <div className="organic-container flex-row">
          <div className="text-side reveal fade-right">
            <h2>Our Roots</h2>
            <p>
              Amaravathi Naturo Tech began with a single promise: to treat the land with respect.
              Today, we have grown into a community of over 5000+ farmers, all dedicated to
              ethical cultivation of premium wood and medicinal crops.
            </p>
            <p>
              We believe in transparency. From the seed planted in the nursary to the
              final product in your hand, every step is traceable and pure.
            </p>
            <button className="btn-organic">Read Our Story <ArrowRight size={18} /></button>
          </div>
          <div className="image-side glass-panel reveal fade-left">
            <img
              src="https://res.cloudinary.com/drevfgyks/image/upload/v1724859736/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/creative-lush-green-leaves-pattern-nature-texture-background_uft57t.jpg"
              alt="Organic Pattern"
              className="rounded-img"
            />
          </div>
        </div>
      </section>

      {/* 4. Soft Stats */}
      <section className="soft-stats">
        <div className="organic-container">
          <div className="stats-row glass-panel reveal fade-up">
            <div className="stat-pill">
              <span className="sc-num">20+</span>
              <span className="sc-label">Years</span>
            </div>
            <div className="divider"></div>
            <div className="stat-pill">
              <span className="sc-num">350+</span>
              <span className="sc-label">Projects</span>
            </div>
            <div className="divider"></div>
            <div className="stat-pill">
              <span className="sc-num">5000+</span>
              <span className="sc-label">Farmers</span>
            </div>
            <div className="divider"></div>
            <div className="stat-pill">
              <span className="sc-num">26</span>
              <span className="sc-label">States</span>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Minimal Map & Contact */}
      <section className="map-minimal">
        <div className="organic-container">
          <div className="map-card glass-panel reveal zoom-in">
            <div className="map-text">
              <h2>Growing Nationwide</h2>
              <p>Our roots may be local, but our branches reach across India.</p>
              <div className="tags">
                <span className="tag"><Map size={14} /> Hyderabad HQ</span>
                <span className="tag"><Users size={14} /> 278 Dealers</span>
              </div>
              <div className="contact-details mt-4">
                <p><strong>Email:</strong> amaravathinatural@gmail.com</p>
                <p><strong>Phone:</strong> 9866672765</p>
              </div>
            </div>
            <div className="map-visual">
              <img src="https://res.cloudinary.com/drevfgyks/image/upload/v1729409372/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Screenshot_2024-10-20_125800_ueo152.png" alt="Map" />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUs;
